import { call, put, select, takeLatest } from 'redux-saga/effects'

import {
  AuthActionTypes,
  resendVerificationError,
  resendVerificationRequest,
  resendVerificationSuccess,
} from '@store/auth'
import { selectResendCompleteSignupVerificationLink } from '@store/rootResource'
import { Toaster } from '@tribegroup'
import { networkRequest } from '@utils'

export function* handleResendVerificationRequest(
  action: ReturnType<typeof resendVerificationRequest>,
) {
  try {
    const { email, history, toastMessage } = action.payload

    const link = yield select(selectResendCompleteSignupVerificationLink)

    yield call(networkRequest, link.method, link.href, {
      email,
    })
    yield put(resendVerificationSuccess())
    if (history) {
      yield call(history.push, `/signUpConfirmation?email=${encodeURIComponent(email)}`)
    }
    if (toastMessage) {
      yield call(Toaster.toast, toastMessage)
    }
  } catch (error) {
    yield put(resendVerificationError(error))
  }
}

export function* watchResendVerificationRequest() {
  yield takeLatest(AuthActionTypes.RESEND_VERIFICATION_REQUEST, handleResendVerificationRequest)
}
